import React from "react";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import parseMediaUrl from "../../functions/parseMediaUrl";
import MediaDescriptionRender from "./MediaDescriptionRender";
import StaticBox from "../../../frontend/templates/StaticSlide/Box";

const PreviewBoxContainer = (item) => {
  // return <div>test</div>;
  return;
};

export function Preview(props) {
  const { item, feedType, countries } = props;
  const updatedAtPrefix = new Date(item.updatedAt).getTime();

  return (
    <div key={item.uuid} className={"preview-item"}>
      <div className={"media-actions"}></div>
      <div className={"preview-item-av"}>
        <img src={parseMediaUrl(item.url) + `?updated_at=${updatedAtPrefix}`} />
      </div>
      <div className="preview-box-container">
        <StaticBox
          slide={item}
          feedType={feedType}
          countries={countries}
          isPreview={true}
        />
      </div>
    </div>
  );
}
